import { BrowserRouter, Route, Switch } from "react-router-dom";
import "./App.css";
import Home from "./Component/Home";
import AbuDhabiPage from "./Component/AbuDhabi";
import Dubai from "./Component/Dubai";
import SingaporePage from "./Component/Singapore";
import LandingPageDubai from "./LandingPages/LandingPageDubai";
import LandingPageSingapore from "./LandingPages/LandingPageSingapore";

function App() {
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/dubai" component={Dubai} />
        <Route exact path="/abudhabi" component={AbuDhabiPage} />
        <Route exact path="/singapore" component={SingaporePage} />

        <Route exact path="/mahalaxmi-dubai" component={LandingPageDubai} />
        <Route exact path="/mahalaxmi-singapore" component={LandingPageSingapore} />
      </Switch>
    </BrowserRouter>
  );
}

export default App;
